const OTHER_DELIVERY_PLACE_OPTION_VALUE = -1;

export { OTHER_DELIVERY_PLACE_OPTION_VALUE };
